import { RightOutlined } from '@ant-design/icons';
import { Breadcrumb, Card, Col, Row } from 'antd';
import set1 from './images/Group 3041.svg';
import set2 from './images/set2.svg';
import set3 from './images/empSbg.svg';
// import set4 from './images/Group 31.svg';
import set5 from './images/Sbg.svg';
import set6 from './images/Iconn.svg';
import set7 from './images/div.svg';
import arrow from './images/Vector 9.svg';
import styles from './index.module.less';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllPlants,
  getAllDepartments,
  getAllCategories,
  getAllSubCategories,
  getAllDesignations,
  getCostCenterNum,
  getAllUsers,
  getAllDoaList,
  getAlldelegations
} from '../../redux/slice';

const SettingsPage = () => {
  const dispatch = useDispatch();
  const {
    plant_pagination,
    department_pagination,
    category_pagination,
    sbu_pagination,
    designation_master_pagination,
    cost_center_pagination,
    user_pagination,
    list_pagination,
    delegation_pagination
  } = useSelector((state) => state.settings);

  useEffect(() => {
    dispatch(getAllPlants({ page: 1 }));
    dispatch(getAllDepartments({ page: 1 }));
    dispatch(getAllCategories({ page: 1 }));
    dispatch(getAllSubCategories({ page: 1 }));
    dispatch(getAllDesignations({ page: 1 }));
    dispatch(getCostCenterNum({ page: 1 }));
    dispatch(getAllUsers({ page: 1 }));
    dispatch(getAllDoaList({ page: 1 }));
    dispatch(getAlldelegations({ page: 1 }));
  }, []);

  const settingsData = [
    // {
    //   title: 'BUs',
    //   subtitle: 'Configure BUs',
    //   navigation: '/settings/bu',
    //   image: set1
    // },
    // {
    //   title: 'SBUs',
    //   subtitle: 'Configure SBUs',
    //   navigation: '/settings/sbu',
    //   image: set5
    // },
    // {
    //   title: 'Projects',
    //   subtitle: 'Configure Projects',
    //   navigation: '/settings/projects',
    //   image: set4
    // },
    // {
    //   title: 'User Matrix',
    //   subtitle: 'Map users to designations',
    //   navigation: '/settings/designations-new',
    //   image: set3
    // },
    // {
    //   title: 'Designations',
    //   subtitle: 'Configure Designations',
    //   navigation: '/settings/designation',
    //   image: set2
    // },
    // {
    //   title: 'Designation Mapping',
    //   subtitle: 'Configure Designation Mapping',
    //   navigation: '/settings/designation-mapping',
    //   image: set3
    // },
    // {
    //   title: 'SBGs',
    //   subtitle: 'Configure SBGs',
    //   navigation: '/settings/sbg',
    //   image: set4
    // },
    // {
    //   title: 'Approval Roles',
    //   subtitle: 'Configure Approval Roles',
    //   navigation: '/settings/approver',
    //   image: set1
    // },
    {
      title: 'Plants',
      subtitle: 'Configure Plants',
      navigation: '/settings/plants',
      image: set1,
      count: plant_pagination?.total_records ?? null
    },
    {
      title: 'Departments',
      subtitle: 'Configure Departments',
      navigation: '/settings/departments',
      image: set3,
      count: department_pagination?.total_records ?? null
    },
    {
      title: 'Delegation Management',
      subtitle: 'Configure user delegation rules and periods',
      navigation: '/settings/delegation-management',
      image: set7,
      count: delegation_pagination?.total_records ?? null
    },
    {
      title: 'Categories',
      subtitle: 'Configure Categories',
      navigation: '/settings/categories',
      image: set5,
      count: category_pagination?.total_records ?? null
    },
    {
      title: 'Sub-Categories',
      subtitle: 'Configure Sub-Categories',
      navigation: '/settings/sub-categories',
      image: set2,
      count: sbu_pagination?.total_records ?? null
    },
    {
      title: 'Designations',
      subtitle: 'Create and Manage Designations',
      navigation: '/settings/designations',
      image: set6,
      count: designation_master_pagination?.total_records ?? null
    },
    {
      title: 'Cost Center',
      subtitle: 'Create and Manage Cost Center',
      navigation: '/settings/costnumber',
      image: set6,
      count: cost_center_pagination?.total_records ?? null
    },
    {
      title: 'User Management',
      subtitle: 'Create and Manage User Management',
      navigation: '/settings/usermanagement',
      image: set3,
      count: user_pagination?.total_records ?? null
    },
    {
      title: 'DOA Flows',
      subtitle: 'Create and Manage DOA Flows',
      navigation: '/settings/doa-flows',
      image: set6,
      count: list_pagination?.total_records ?? null
    }
  ];

  return (
    <>
      <div className={`${styles.breadcrub_container}`}>
        {' '}
        <Breadcrumb separator={<RightOutlined />}>
          <Breadcrumb.Item href="/settings">Settings</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Row className="mt-5">
        {settingsData?.map((item, index) => (
          <Col key={index} span={24}>
            <Link to={item.navigation}>
              <Card hoverable className={`mb-3 ${styles.settings_card}`}>
                <Row>
                  <Col span={20}>
                    <Row>
                      <Col>
                        {' '}
                        <img src={item.image} className="mr-2" />{' '}
                      </Col>

                      <Col span={10}>
                        <span className="sfprotext-bold font-14">
                          {item.title}
                        </span>
                        <br />
                        <span className="sfprotext-regular font-12">
                          {item.subtitle}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="df-jc-ac text-right" span={4}>
                    <img src={arrow} className="" />{' '}
                  </Col>
                </Row>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default SettingsPage;
